module.exports = __webpack_public_path__ + "img/蒙版组 17@2x.a10bccdb.webp";